<ng-template appTemplatePortal>
    <mat-toolbar *ngIf="messages?.length > 0"
                 color="{{determineToolbarColor(messages[0])}}"
                 id="global-message-toolbar">
        <mat-icon>warning</mat-icon>
        <p class="global-message">{{messages[0].message}}</p>
        <button (click)="dismissMessage(messages[0])" mat-stroked-button>Dismiss</button>
    </mat-toolbar>
</ng-template>
